import React, { Component } from 'react'
import injectSheet from 'react-jss'
import { Col } from 'react-bootstrap'
import { withApollo } from 'react-apollo'
import { getMediaQuerySize } from 'src/utils'
import MapCore from './components/MapCore'

const styles = theme => {
  const mediaQuery = getMediaQuerySize()
  return {
    mapclass: {
      width: '100%',
      height: 320
    },
    mapclassAF: {
      width: '100%'
    },
    divMap: {
      backgroundColor: 'white',
      paddingTop: 15,
      minHeight: theme.minHeight
    },
    divMapAF: {
      backgroundColor: 'rgba(255,255,255, 0)',
      position: 'fixed',
      bottom: 0,
      right: 0,
      width: '66.66%',
      height: `calc(100vh - 268px)`,
      [mediaQuery]: {
        height: `calc(100vh - 204px)`
      }
    },
    alertZoom: {
      margin: 0,
      display: 'inline-block',
      position: 'absolute',
      top: 15,
      right: 15,
      zIndex: 401,
      width: 300
    },
    alertZoomAF: {
      margin: 0,
      display: 'inline-block',
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: 401
    }
  }
}

let LeafletMap
class MapProducersInZone extends Component {
  constructor(props) {
    super(props)
    this.mapRef = React.createRef()
    this.state = {
      heightWindow:
        typeof window !== 'undefined' ? window.innerHeight - 204 : 600 - 204,
      infoProducer: null,
      defaultZoom: 8
    }
    if (typeof window !== 'undefined') {
      LeafletMap = require('react-leaflet').Map
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => this.updateWindowHeight())
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', () => this.updateWindowHeight())
    }
  }

  updateWindowHeight = () => {
    this.setState({
      heightWindow:
        typeof window !== 'undefined' ? window.innerHeight - 204 : 600 - 204
    })
  }

  render() {
    const { classes, data, bounds, coordinates, minZoom = 0, zoom } = this.props
    const producers = data || null

    return (
      <>
        {typeof window !== 'undefined' ? (
          window.innerWidth < 768 ? (
            <Col xs={12} className={`visible-xs-block ${classes.divMap}`}>
              {coordinates ? (
                <LeafletMap
                  center={{ lng: coordinates.x, lat: coordinates.y }}
                  zoom={zoom || this.state.defaultZoom}
                  className={classes.mapclass}
                  doubleClickZoom={false}
                  ref={this.mapRef}
                  minZoom={minZoom}
                >
                  {producers && <MapCore producers={producers} />}
                </LeafletMap>
              ) : (
                <LeafletMap
                  bounds={bounds}
                  className={classes.mapclass}
                  doubleClickZoom={false}
                  ref={this.mapRef}
                  minZoom={minZoom}
                >
                  {producers && <MapCore producers={producers} />}
                </LeafletMap>
              )}
            </Col>
          ) : (
            <div className={`${classes.divMapAF} hidden-xs`}>
              {coordinates ? (
                <LeafletMap
                  center={{ lng: coordinates.x, lat: coordinates.y }}
                  zoom={zoom || this.state.defaultZoom}
                  style={{ height: this.state.heightWindow }}
                  className={classes.mapclassAF}
                  doubleClickZoom={false}
                  ref={this.mapRef}
                  minZoom={minZoom}
                >
                  {producers && <MapCore producers={producers} />}
                </LeafletMap>
              ) : (
                <LeafletMap
                  bounds={bounds}
                  className={classes.mapclassAF}
                  style={{ height: this.state.heightWindow }}
                  doubleClickZoom={false}
                  ref={this.mapRef}
                  minZoom={minZoom}
                >
                  {producers && <MapCore producers={producers} />}
                </LeafletMap>
              )}
            </div>
          )
        ) : (
          <span />
        )}
      </>
    )
  }
}

const mapWithApollo = withApollo(MapProducersInZone)
export default injectSheet(styles)(mapWithApollo)
